import { TableFilterDatePicker } from '@/components/table/table-filter-date-picker';
import { instantToDate } from '@airreading/common';
import { ComponentProps } from 'react';
import { Temporal } from 'temporal-polyfill';

interface TableFilterPlainDatePickerProps {
  selectedPlainDateString?: string;
  onPlainDateSelect: (newPlainDateString?: string) => void;
  tableFilterDatePickerProps?: ComponentProps<typeof TableFilterDatePicker>;
  onClear?: () => void;
}

export const TableFilterPlainDatePicker = ({
  selectedPlainDateString,
  onPlainDateSelect,
  tableFilterDatePickerProps,
  onClear,
}: TableFilterPlainDatePickerProps) => {
  const { calendarProps = {}, ...others } = tableFilterDatePickerProps || {};
  return (
    <TableFilterDatePicker
      {...others}
      onClear={() => onClear?.()}
      calendarProps={{
        ...calendarProps,
        selected: selectedPlainDateString
          ? instantToDate(
              Temporal.PlainDate.from(selectedPlainDateString)
                .toZonedDateTime(Temporal.Now.timeZoneId())
                .startOfDay()
                .toInstant(),
            )
          : undefined,
        onSelect: (newDate) => {
          onPlainDateSelect(
            newDate
              ? Temporal.Instant.from(newDate.toISOString())
                  .toZonedDateTimeISO(Temporal.Now.timeZoneId())
                  .toPlainDate()
                  .toString()
              : undefined,
          );
        },
      }}
    />
  );
};
